// import { groupBy } from "lodash"
// import { dateRangeFormat, days_between } from "../../util";

import { isEmpty } from "lodash";
import {
  checkNull,
  checkUndefined,
  getCurrencySymbol,
  removeDuplicatesActivity,
} from "../../util";

export function fetchVideosImages(videos) {
  let videoArr = [];
  let imageArr = [];
  videos.forEach((element) => {
    if (!isEmpty(element.video_url)) {
      videoArr.push({
        videoUrl: element.video_url.med,
        videoThumbnail: element.image.twoX.fullscreen,
      });
    } else {
      if (element.image) {
        imageArr.push(element.image.twoX.fullscreen);
      }
    }
  });

  return {
    length: videoArr.length + imageArr.length,
    video: videoArr,
    image: imageArr,
  };
}

export function overviewModel(trip_days) {
  const destinationList = [];

  trip_days.forEach((item) => {
    let alreadyExist = false;
    let id = item.neighbourhood_info.id;

    if (destinationList.length > 0) {
      let lastObj = destinationList[destinationList.length - 1];
      // console.log(lastObj)
      if (lastObj.destinationId === id) {
        alreadyExist = true;
        lastObj.date.push(item.date);
        lastObj.days.push(item.day);
        lastObj.notes.push(...getAllNotes(item.neighbourhood_info.notes));
        destinationList[destinationList.length - 1] = lastObj;
      }
    }

    if (alreadyExist === false) {
      destinationList.push({
        date: [item.date],
        days: [item.day],
        image: item.neighbourhood_info.image.twoX.thumbnail,
        destinationId: item.neighbourhood_info.id,
        destinationName: item.neighbourhood_info.display_name,
        notes: getAllNotes(item.neighbourhood_info.notes),
      });
    }
  });

  destinationList.map((destination) => {
    let list = getActivtyForDestination(destination.days, trip_days);
    destination.activityandStayList = list;
  });

  return destinationList;
}

function getAllNotes(notes) {
  let noteList = [];
  notes.map((note) => {
    noteList.push({ icon: note.icon_name, value: note.value });
  });

  return noteList;
}

function getActivtyForDestination(days, trip_days) {
  let activityList = [];
  let stayList = [];
  days.forEach((day) => {
    if (trip_days.length >= day) {
      let trip_day = trip_days[day - 1];
      // console.log(trip_day)
      let booking_status = "";
      trip_day.itinerary_items.map((item) => {
        if (item.booking_info && item.booking_info.booking_status) {
          booking_status = item.booking_info.booking_status;
        }
        if (item.item_type === "ACTIVITY") {
          activityList.push({
            item: item.display_name,
            booking_status: booking_status,
          });
        }
        if (item.item_type === "HOTEL") {
          stayList.push({
            item: item.display_name,
            booking_status: booking_status,
          });
        }
      });
    }
  });
  let uniqueActivityList = removeDuplicatesActivity(activityList, "item");
  let uniqueStayList = removeDuplicatesActivity(stayList, "item");
  return { uniqueActivityList, uniqueStayList };
}

export function mediaViewModel(trip_days) {
  // console.log(trip_days)
  let mediaDays = [];
  let allIdArr = [];

  let mediaObject = {
    place_title: "",
    image: "",
    rating: "",
    activity_name: "",
    duration: "",
    total_guest: "",
    price: "",
    booking_status: "",
  };
  let stayCount = 0;
  for (let i = 0; i < trip_days.length; i++) {
    mediaDays.push({
      date: trip_days[i].date,
      place_title: trip_days[i].neighbourhood_info.display_name,
      mediaArr: [],
      nextDate: i < trip_days.length - 1 ? trip_days[i + 1].date : "",
      prevDate: i > 0 ? trip_days[i - 1].date : "",
      nextDay: i < trip_days.length - 1 ? trip_days[i + 1].day : "",
      prevDay: i > 0 ? trip_days[i - 1].day : "",
      currentDay: trip_days[i].day,
      idArr: [],
      allId: [],
      totalStays: 0,
      totalStops: 0,
    });

    let presentDayStayCount = 0;
    let stopCount = 0;
    for (let j = 0; j < trip_days[i].itinerary_items.length; j++) {
      let itinerary = trip_days[i].itinerary_items[j];

      // console.log('>>>>', mediaDays[i].allId)

      if (allIdArr.indexOf(itinerary.item_id) === -1) {
        mediaDays[i].idArr.push(trip_days[i].itinerary_items[j].item_id);
        mediaDays[i].mediaArr.push({
          ...mediaObject,
          place_title: itinerary.display_name,
          image: itinerary.images[0].twoX.square,
          video:
            itinerary.hasOwnProperty("videos") && !isEmpty(itinerary.videos)
              ? {
                  src: itinerary.videos[0].video_url.med,
                  thumbnail: itinerary.videos[0].image.twoX.square,
                }
              : "",
          rating:
            itinerary.item_type === "HOTEL"
              ? !checkUndefined(itinerary.properties.star_rating) &&
                itinerary.properties.star_rating !== 0 &&
                itinerary.properties.star_rating + "-star"
              : !checkUndefined(itinerary.properties.review) &&
                itinerary.properties.review.avg_review !== 0 &&
                itinerary.properties.review.avg_review + "/5",
          activity_name: itinerary.properties.primary_sub_category,
          duration: itinerary.properties.duration_min
            ? itinerary.properties.duration_min >= 60
              ? itinerary.properties.duration_min / 60 + " hrs"
              : itinerary.properties.duration_min + " mins"
            : "",
          total_guest:
            itinerary && itinerary.item_type === "HOTEL"
              ? !checkUndefined(itinerary.booking_info) &&
                !checkNull(itinerary.booking_info.booking_status)
                ? itinerary.booking_info.booking_details.rooms &&
                  itinerary.booking_info.booking_details.rooms[0].no_of_adults +
                    itinerary.booking_info.booking_details.rooms[0]
                      .no_of_children
                : ""
              : "",
          price:
            !checkUndefined(itinerary.booking_info) &&
            !checkNull(itinerary.booking_info.booking_status) &
              !isEmpty(itinerary.booking_info.price)
              ? ` ${getCurrencySymbol(
                  itinerary.booking_info.price[0].unit
                )}${Math.round(itinerary.booking_info.price[0].value)}`
              : !checkUndefined(itinerary.properties.price[0])
              ? " " +
                getCurrencySymbol(itinerary.properties.price[0].unit) +
                "" +
                Math.round(itinerary.properties.price[0].value)
              : "",
          currency:
            !checkUndefined(itinerary.booking_info) &&
            !checkNull(itinerary.booking_info.booking_status) &
              !isEmpty(itinerary.booking_info.price)
              ? ` ${getCurrencySymbol(itinerary.booking_info.price[0].unit)}`
              : !checkUndefined(itinerary.properties.price[0])
              ? getCurrencySymbol(itinerary.properties.price[0].unit)
              : "",
          booking_status:
            !checkUndefined(itinerary.booking_info) &&
            !checkNull(itinerary.booking_info.booking_status)
              ? itinerary.booking_info.booking_status
              : "NOT_BOOKED",
          description:
            itinerary.item_type === "ATTRACTION" ? itinerary.description : "",
          item_id: itinerary.item_id,
          item_type: itinerary.item_type,
          stayCounter:
            itinerary.item_type === "HOTEL"
              ? (stayCount = stayCount + 1)
              : stayCount,
          presentDayStayCount:
            itinerary.item_type === "HOTEL"
              ? (presentDayStayCount = presentDayStayCount + 1)
              : presentDayStayCount,
          stopCounter:
            itinerary.item_type === "ATTRACTION" ||
            itinerary.item_type === "ACTIVITY"
              ? (stopCount = stopCount + 1)
              : stopCount,
          city: itinerary.address.city,
          is_default: itinerary.is_default,
        });
      }
    }
    allIdArr.push(...mediaDays[i].idArr);
    mediaDays[i].allId.push(...allIdArr);
    mediaDays[i].totalStays = presentDayStayCount;
    mediaDays[i].totalStops = stopCount;
  }

  return mediaDays;
}

export function stopViewModal(trip_days) {
  let stopViewDays = [];

  let stopViewObj = {
    place_title: "",
    image: "",
    rating: "",
    duration: "",
    total_guest: "",
    price: "",
    booking_status: "",
    notes: "",
    activity_name: "",
  };

  for (let i = 0; i < trip_days.length; i++) {
    stopViewDays.push({
      day: trip_days[i].day,
      date: trip_days[i].date,
      place_title: trip_days[i].neighbourhood_info.display_name,
      booking_status:
        trip_days[i].itinerary_items[0] &&
        trip_days[i].itinerary_items[0].item_type === "HOTEL" &&
        trip_days[i].itinerary_items[0].booking_info
          ? trip_days[i].itinerary_items[0].booking_info.booking_status
          : "",
      stay_info:
        trip_days[i].itinerary_items[0] &&
        trip_days[i].itinerary_items[0].item_type === "HOTEL"
          ? trip_days[i].itinerary_items[0].display_name
          : "",
      stopArr: [],
    });

    for (let j = 0; j < trip_days[i].itinerary_items.length; j++) {
      let itinerary = trip_days[i].itinerary_items[j];
      if (itinerary.item_type !== "HOTEL") {
        stopViewDays[i].stopArr.push({
          ...stopViewObj,
          place_title: itinerary.display_name,
          rating:
            !checkUndefined(itinerary.properties.review) &&
            itinerary.properties.review.avg_review !== 0
              ? itinerary.properties.review.avg_review + "/5"
              : "",
          duration: itinerary.properties.duration_min
            ? itinerary.properties.duration_min >= 60
              ? itinerary.properties.duration_min / 60 + " hrs"
              : itinerary.properties.duration_min + " mins"
            : "",
          total_guest:
            itinerary.item_type === "HOTEL"
              ? !checkUndefined(itinerary.booking_info) &&
                !checkNull(itinerary.booking_info.booking_status)
                ? itinerary.booking_info.booking_details.rooms[0].no_of_adults +
                  itinerary.booking_info.booking_details.rooms[0].no_of_children
                : ""
              : "",
          price:
            !checkUndefined(itinerary.booking_info) &&
            !checkNull(itinerary.booking_info.booking_status) &
              !isEmpty(itinerary.booking_info.price)
              ? ` ${getCurrencySymbol(
                  itinerary.booking_info.price[0].unit
                )}${Math.round(itinerary.booking_info.price[0].value)}`
              : !checkUndefined(itinerary.properties.price[0])
              ? " " +
                getCurrencySymbol(itinerary.properties.price[0].unit) +
                "" +
                Math.round(itinerary.properties.price[0].value)
              : "",
          booking_status:
            itinerary.item_type !== "ATTRACTION"
              ? !checkUndefined(itinerary.booking_info) &&
                !checkNull(itinerary.booking_info.booking_status)
                ? itinerary.booking_info.booking_status
                : "NOT_BOOKED"
              : "",
          notes: !isEmpty(itinerary.notes) ? itinerary.notes : [],
          image: itinerary.images[0].twoX.thumbnail,
          activity_name: itinerary.properties.primary_sub_category,
          item_type: itinerary.item_type,
          description:
            itinerary.item_type === "ATTRACTION" ? itinerary.description : "",
          item_id: itinerary.item_id,
          suggestion_stops: !isEmpty(itinerary.linked_items)
            ? itinerary.linked_items.items
            : "",
          item_type: itinerary.item_type,
          city: itinerary.address.city,
          currency:
            !checkUndefined(itinerary.booking_info) &&
            !checkNull(itinerary.booking_info.booking_status) &
              !isEmpty(itinerary.booking_info.price)
              ? ` ${getCurrencySymbol(itinerary.booking_info.price[0].unit)}`
              : !checkUndefined(itinerary.properties.price[0])
              ? getCurrencySymbol(itinerary.properties.price[0].unit)
              : "",
          is_default: itinerary.is_default,
        });
      }
    }
  }

  return stopViewDays;
}

export function stayViewModel(trip_days) {
  let stayViewDays = [];

  let stayObject = {
    booking_status: "",
    image: "",
    place_title: "",
    rating: "",
    total_guest: "",
    price: "",
    notes: "",
  };

  for (let i = 0; i < trip_days.length; i++) {
    for (let j = 0; j < trip_days[i].itinerary_items.length; j++) {
      if (trip_days[i].itinerary_items[j].item_type === "HOTEL") {
        let itinerary = trip_days[i].itinerary_items[j];
        stayViewDays.push({
          place_title: trip_days[i].neighbourhood_info.display_name,
          id: trip_days[i].itinerary_items[j].item_id,
          date: trip_days[i].date,
          day: trip_days[i].day,
          stayDetail: {
            ...stayObject,
            booking_status:
              !checkUndefined(itinerary.booking_info) &&
              !checkNull(itinerary.booking_info.booking_status)
                ? itinerary.booking_info.booking_status
                : "NOT_BOOKED",
            image: itinerary.images[0].twoX.thumbnail,
            place_title: itinerary.display_name,
            rating:
              !checkUndefined(itinerary.properties.star_rating) &&
              itinerary.properties.star_rating !== 0
                ? itinerary.properties.star_rating + "-star"
                : "",
            total_guest:
              !checkUndefined(itinerary.booking_info) &&
              !checkNull(itinerary.booking_info.booking_status)
                ? itinerary.booking_info.booking_details.rooms &&
                  itinerary.booking_info.booking_details.rooms[0].no_of_adults +
                    itinerary.booking_info.booking_details.rooms[0]
                      .no_of_children
                : "",
            price:
              !checkUndefined(itinerary.booking_info) &&
              !checkNull(itinerary.booking_info.booking_status) &
                !isEmpty(itinerary.booking_info.price)
                ? ` ${getCurrencySymbol(
                    itinerary.booking_info.price[0].unit
                  )}${Math.round(itinerary.booking_info.price[0].value)}`
                : !checkUndefined(itinerary.properties.price[0])
                ? " " +
                  getCurrencySymbol(itinerary.properties.price[0].unit) +
                  "" +
                  Math.round(itinerary.properties.price[0].value)
                : "",
            notes: !isEmpty(itinerary.notes) ? itinerary.notes : [],
            item_id: itinerary.item_id,
            suggestion_stays: !isEmpty(itinerary.linked_items)
              ? itinerary.linked_items.items
              : "",
            item_type: itinerary.item_type,
            city: itinerary.address.city,
            currency:
              !checkUndefined(itinerary.booking_info) &&
              !checkNull(itinerary.booking_info.booking_status) &
                !isEmpty(itinerary.booking_info.price)
                ? ` ${getCurrencySymbol(itinerary.booking_info.price[0].unit)}`
                : !checkUndefined(itinerary.properties.price[0])
                ? getCurrencySymbol(itinerary.properties.price[0].unit) + ""
                : "",
            is_default: itinerary.is_default,
          },
        });
      }
    }

    // if (
    //   trip_days[i].itinerary_items[0] &&
    //   trip_days[i].itinerary_items[0].item_type === 'HOTEL'
    // ) {
    //   let itinerary = trip_days[i].itinerary_items[0]
    //   stayViewDays.push({
    //     place_title: trip_days[i].neighbourhood_info.display_name,
    //     id: trip_days[i].itinerary_items[0].item_id,
    //     date: trip_days[i].date,
    //     day: trip_days[i].day,
    //     stayDetail: {
    //       ...stayObject,
    //       booking_status:
    //         !checkUndefined(itinerary.booking_info) &&
    //         !checkNull(itinerary.booking_info.booking_status)
    //           ? itinerary.booking_info.booking_status
    //           : 'NOT_BOOKED',
    //       image: itinerary.images[0].twoX.thumbnail,
    //       place_title: itinerary.display_name,
    //       rating: !checkUndefined(itinerary.properties.star_rating)
    //         ? itinerary.properties.star_rating + '-star'
    //         : '',
    //       total_guest:
    //         !checkUndefined(itinerary.booking_info) &&
    //         !checkNull(itinerary.booking_info.booking_status)
    //           ? itinerary.booking_info.booking_details.rooms &&
    //             itinerary.booking_info.booking_details.rooms[0].no_of_adults +
    //               itinerary.booking_info.booking_details.rooms[0].no_of_children
    //           : '',
    //       price:
    //         !checkUndefined(itinerary.booking_info) &&
    //         !checkNull(itinerary.booking_info.booking_status) &
    //           !isEmpty(itinerary.booking_info.price)
    //           ? ` ${getCurrencySymbol(
    //               itinerary.booking_info.price[0].unit,
    //             )}${Math.round(itinerary.booking_info.price[0].value)}`
    //           : !checkUndefined(itinerary.properties.price[0])
    //           ? ' ' +
    //             getCurrencySymbol(itinerary.properties.price[0].unit) +
    //             '' +
    //             Math.round(itinerary.properties.price[0].value)
    //           : '',
    //       notes: !isEmpty(itinerary.notes) ? itinerary.notes : [],
    //       item_id: itinerary.item_id,
    //       suggestion_stays: !isEmpty(itinerary.linked_items)
    //         ? itinerary.linked_items.items
    //         : '',
    //       item_type: itinerary.item_type,
    //     },
    //   })
    // } else {
    //   stayViewDays.push({
    //     place_title: trip_days[i].neighbourhood_info.display_name,
    //     id: trip_days[i].itinerary_items[0]
    //       ? trip_days[i].itinerary_items[0].item_id
    //       : '',
    //     date: trip_days[i].date,
    //     stayDetail: '',
    //     day: trip_days[i].day,
    //   })
    // }
  }

  let uniqueStayList = [];
  stayViewDays.map((stay) => {
    let alreadyExist = false;
    let id = stay.id;
    if (uniqueStayList.length > 0) {
      let lastObj = uniqueStayList[uniqueStayList.length - 1];
      if (lastObj.id === id) {
        alreadyExist = true;
        lastObj.date.push(stay.date);
        lastObj.day.push(stay.day);
        uniqueStayList[uniqueStayList.length - 1] = lastObj;
      }
    }

    if (alreadyExist === false) {
      let obj = {};
      obj.place_title = stay.place_title;
      obj.id = stay.id;
      obj.date = [stay.date];
      obj.day = [stay.day];
      obj.stayDetail = stay.stayDetail;
      uniqueStayList.push(obj);
    }
  });

  return uniqueStayList;
}
